import { Blue, Neutral, Yellow } from 'glints-aries/lib/@next/utilities/colors';

export const SGGradients = {
  /** Keep copy-side stops at S100/S99 so white text meets 4.5:1 contrast. */
  hero: `linear-gradient(135deg, ${Blue.S100} 0%, ${Blue.S99} 45%, ${Blue.Brand} 80%, ${Blue.S54} 100%)`,
  blue: `linear-gradient(135deg, ${Blue.Brand} 0%, ${Blue.S99} 100%)`,
  softTop: `linear-gradient(180deg, ${Neutral.B100} 0%, ${Neutral.B99} 100%)`,
  cardHeaderBlue: `linear-gradient(180deg, ${Blue.S08} 0%, ${Neutral.B100} 100%)`,
  cardHeaderYellow: `linear-gradient(180deg, ${Yellow.S45} 0%, ${Neutral.B100} 100%)`,
};

export const CARD_SHADOW_HOVER = `0 4px 10px rgba(71, 71, 71, 0.18), 0 0 6px rgba(71, 71, 71, 0.1)`;

export const CONTENT_MAX_WIDTH = 1120;

/**
 * Mobile breakpoint (px) shared across the SG landing components. The other
 * breakpoints come from `ScreenSize` in glints-aries; this one has no
 * glints-aries equivalent so it lives here.
 */
export const MOBILE_BREAKPOINT = 480;

export const getTalentHubLandingLinks = (employersBaseURL: string) =>
  ({
    hire: employersBaseURL,
    hireSignup: `${employersBaseURL}/signup`,
    singaporeJobs: '/sg/opportunities/jobs/',
    aiAgents: 'https://ai.glints.com/',
    talentHub: 'https://talenthub.glints.com/',
  }) as const;

export interface PartnerLogo {
  id: string;
  name: string;
  alt: string;
  /**
   * Multiplier applied to the base marquee logo height so individual logos
   * with extra internal whitespace can be visually balanced against the rest.
   * Defaults to 1.
   */
  scale?: number;
  /**
   * When true, the logo is rendered as a pure-black silhouette via
   * `filter: brightness(0)`. Use for source files that contain white text
   * intended for a dark background (e.g. Far East Organization).
   */
  tintBlack?: boolean;
}

export const PARTNER_LOGOS: PartnerLogo[] = [
  { id: 'aia', name: 'logos/aia.png', alt: 'AIA' },
  { id: 'fwd', name: 'logos/fwd.png', alt: 'FWD' },
  { id: 'microsoft', name: 'logos/microsoft.png', alt: 'Microsoft' },
  { id: 'carousell', name: 'logos/carousell.png', alt: 'Carousell' },
  { id: 'getgo', name: 'logos/getgo.png', alt: 'GetGo' },
  {
    id: 'ntuc-learninghub',
    name: 'logos/ntuc-learninghub.png',
    alt: 'NTUC LearningHub',
  },
  {
    id: 'scmp',
    name: 'logos/scmp.png',
    alt: 'South China Morning Post',
    scale: 1.4,
  },
  { id: 'youtrip', name: 'logos/youtrip.png', alt: 'YouTrip' },
  {
    id: 'far-east-organization',
    name: 'logos/far-east-organization.png',
    alt: 'Far East Organization',
    tintBlack: true,
  },
  {
    id: 'appen',
    name: 'logos/appen.png',
    alt: 'Appen',
    scale: 2.0,
  },
  { id: 'watsons', name: 'logos/watsons.png', alt: 'Watsons' },
  { id: 'rga', name: 'logos/rga.png', alt: 'R/GA', scale: 1.4 },
  { id: 'sunmark', name: 'logos/sunmark.png', alt: 'Partner' },
];
